import TabsMain from "Pages/MyScheduleBeta/Components/Tabs/TabsMain";
import React from "react";

const MyScheduleBetaBody = () => {
  return <TabsMain />;
};

export default MyScheduleBetaBody;
